<page-grid [gridConfig]="agentsGrid" (gridClickColumn)="openDialog($event)" />